import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import useApi from '@/hooks/useApi/useApi';

type CalendarInfo = {
  calendar_url: string;
  calendar_token: string;
};

export const useCalendarInfo = (accountId: string | number) => {
  const { axiosInstance } = useApi();

  return useQuery<CalendarInfo>({
    queryKey: ['calendar-info', accountId],
    queryFn: async () => {
      const { data } = await axiosInstance.get(`/api/v1/accounts/${accountId}/calendar_info`);
      return data;
    },
  });
};

export const useRegenerateCalendarToken = (accountId: string | number) => {
  const { axiosInstance } = useApi();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async () => {
      const { data } = await axiosInstance.post(
        `/api/v1/accounts/${accountId}/regenerate_calendar_token`
      );
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['calendar-info', accountId],
      });
    },
  });
};
